import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import type { TabToShow } from "@/api/types";
import type { TradeDetailsTabsVariant } from "@/components/custom/trade-details-tabs";

const tabToShowValues: [TabToShow, ...TabToShow[]] = [
  "details",
  "matching",
  "related",
  "bdi",
  "idi",
  "messages",
  "audit",
  "notes",
  "exceptions",
  "nack",
  "tba",
  "progress",
];

const categoryValues: [TradeDetailsTabsVariant, ...TradeDetailsTabsVariant[]] =
  ["block", "allocation", "message"];

const tabToShowEnum = z.enum(tabToShowValues);
const categoryEnum = z.enum(categoryValues);

const tradeDetailsSearchSchema = z.object({
  sysId: z.coerce.number(),
  wiid: z.coerce.number(),
  category: categoryEnum,
  ticketType: z.string(),
  tabToShow: tabToShowEnum.optional(),
});

export type TradeDetailsSearch = z.infer<typeof tradeDetailsSearchSchema>;

export const Route = createFileRoute("/trade-details")({
  validateSearch: tradeDetailsSearchSchema,
  staticData: { breadcrumb: "Trade Details" },
});
